import styled from 'styled-components';
import { s } from './NPL.styles';
import { ReportFormatNumber } from '../../../../func/Function';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface IExpectedDividendAnalysisProps {
  expectedDividendAnalysis: ReturnType<
    NplCalculation['getExpectedDividendAnalysis']
  >;
}

/** 공통: 한 줄 행 (좌 라벨 / 우 컨텐츠) */
const ItemRow = ({
  label,
  content,
  color,
}: {
  label: React.ReactNode;
  content: React.ReactNode;
  color?: string;
}) => (
  <s.Item>
    <s.ItemLabel style={color ? { color } : undefined}>{label}</s.ItemLabel>
    <s.ItemContent style={color ? { color } : undefined}>
      {content}
    </s.ItemContent>
  </s.Item>
);

const ExpectedDividendAnalysis = (props: IExpectedDividendAnalysisProps) => {
  const { expectedDividendAnalysis } = props;

  const rows = [
    {
      label: '낙찰가 (예상)',
      content: ReportFormatNumber(expectedDividendAnalysis.row1_1),
    },
    {
      label: '선순위 합계금액',
      content: ReportFormatNumber(expectedDividendAnalysis.row2_1),
    },
    {
      label: '배당 준비액',
      content: ReportFormatNumber(expectedDividendAnalysis.row3_1),
      color: '#008AFF',
    },
    {
      label: '채권최고액',
      content: ReportFormatNumber(expectedDividendAnalysis.row1_2),
    },
    {
      label: '대출원리금 합계 (예상)',
      content: ReportFormatNumber(expectedDividendAnalysis.row2_2),
    },
    {
      label: (
        <>
          대출채권 청구 가능금액
          <br />
          (연체이자 포함)
        </>
      ),
      content: ReportFormatNumber(expectedDividendAnalysis.row3_2),
      color: '#008AFF',
    },
  ];

  return (
    <s.Div>
      <s.Title>예상 배당분석</s.Title>

      {/* 본문 리스트 (Table 제거) */}
      <div>
        {rows.map((r, i) => (
          <ItemRow
            key={i}
            label={r.label}
            content={r.content}
            color={(r as any).color}
          />
        ))}
      </div>
      <div>
        <s.BlueBox>
          <s.LeftCell style={{ color: '#222222' }}>
            본건 배당액 (예상)
          </s.LeftCell>
          <s.RightCell style={{ color: '#008AFF', fontWeight: '700' }}>
            {ReportFormatNumber(expectedDividendAnalysis.row4)}
          </s.RightCell>
        </s.BlueBox>

        <s.Description style={{ marginTop: '8px' }}>
          <img
            src="/assets/images/icon/info_16.svg"
            alt=""
            style={{ width: 16 }}
          />
          <span>
            선순위내역과 예상 대출원리금 산정에 따라 배당액은 변동될 수
            있습니다.
          </span>
        </s.Description>
      </div>
    </s.Div>
  );
};

export default ExpectedDividendAnalysis;
